import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _PropTypes from 'prop-types';
import * as React from 'react';
import styled from 'styled-components';
import { useIsTruncated } from '../../hooks/use_is_truncated.js';
import { spacing1x, spacing2x } from '../../styles/spacing.js';
import { bindRefs } from '../../utils/react.js';
import { Tooltip } from '../Tooltip/Tooltip.js';
import { jsx, jsxs } from 'react/jsx-runtime';

var _excluded = ["children", "as", "tooltipProps"];
var TabWrapper = styled.div.withConfig({
  displayName: "StyledTab__TabWrapper",
  componentId: "imh233-0"
})(["&&{flex:0 1 auto;min-width:120px;padding:0 8px;}"]);
var TabBorder = styled.div.withConfig({
  displayName: "StyledTab__TabBorder",
  componentId: "imh233-1"
})(["&&{background:", ";border-radius:", " ", " 0 0;height:", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.CTAColors.primary;
}, spacing1x, spacing1x, spacing1x);
var TextWrapper = styled.div.withConfig({
  displayName: "StyledTab__TextWrapper",
  componentId: "imh233-2"
})(["&&{font-weight:normal;height:28px;max-width:200px;min-width:0%;overflow:hidden;padding:", ";text-decoration:none;text-overflow:ellipsis;white-space:nowrap;width:100%;}&&:focus,&&:active{outline:none;text-decoration:none;}"], spacing1x);
var Tab = styled.div.withConfig({
  displayName: "StyledTab__Tab",
  componentId: "imh233-3"
})(["&&{border-radius:", " ", " 0 0;cursor:pointer;display:block;font-size:14px;line-height:20px;margin:0 ", ";text-align:center;}&&:focus{outline:none;text-decoration:none;box-shadow:", ";}&&:first-of-type{margin-left:0;}&&:last-of-type{margin-right:0;}&& > ", "{visibility:hidden;}&&[aria-selected='true'] > ", ",&&[aria-selected='true'] > ", " *,&&[aria-current='page'] > ", ",&&[aria-current='page'] > ", " *{color:", ";}&&[aria-selected='true'] > ", ",&&[aria-current='page'] > ", "{visibility:visible;}&& ", ",&& ", " *{color:", ";}&& ", ":hover,&& ", ":hover *{color:", ";}"], spacing1x, spacing1x, spacing2x, function (_ref2) {
  var theme = _ref2.theme;
  return "0 0 0 2px " + theme.CTAColors.primaryVariant;
}, TabBorder, TextWrapper, TextWrapper, TextWrapper, TextWrapper, function (_ref3) {
  var theme = _ref3.theme;
  return theme.CTAColors.primary;
}, TabBorder, TabBorder, TextWrapper, TextWrapper, function (_ref4) {
  var theme = _ref4.theme;
  return theme.neutralColors.charcoal;
}, TextWrapper, TextWrapper, function (_ref5) {
  var theme = _ref5.theme;
  return theme.CTAColors.primaryVariant;
});
var defaultElement = "div";
var StyledTab = /*#__PURE__*/React.forwardRef(function StyledTab2(props, ref) {
  var _textRef$current;

  var children = props.children,
      _props$as = props.as,
      as = _props$as === void 0 ? defaultElement : _props$as,
      tooltipProps = props.tooltipProps,
      rest = _objectWithoutProperties(props, _excluded);

  var localRef = React.useRef(null);
  var textRef = React.useRef(null);
  var truncated = useIsTruncated(textRef);
  return /*#__PURE__*/jsx(Tooltip, _objectSpread(_objectSpread({
    content: truncated ? (_textRef$current = textRef.current) === null || _textRef$current === void 0 ? void 0 : _textRef$current.innerText : void 0
  }, tooltipProps), {}, {
    children: /*#__PURE__*/jsx(TabWrapper, {
      children: /*#__PURE__*/jsxs(Tab, _objectSpread(_objectSpread({
        as: as
      }, rest), {}, {
        ref: bindRefs(localRef, ref),
        onFocus: function onFocus(e) {
          var _localRef$current, _localRef$current$par;

          e.stopPropagation();
          (_localRef$current = localRef.current) === null || _localRef$current === void 0 ? void 0 : (_localRef$current$par = _localRef$current.parentElement) === null || _localRef$current$par === void 0 ? void 0 : _localRef$current$par.scrollIntoView({
            block: "nearest",
            inline: "nearest"
          });
          if (rest.onFocus) rest.onFocus(e);
        },
        children: [/*#__PURE__*/jsx(TextWrapper, {
          ref: textRef,
          children: children
        }), /*#__PURE__*/jsx(TabBorder, {
          "aria-hidden": true
        })]
      }))
    })
  }));
});
StyledTab.propTypes = {
  "as": _PropTypes.oneOfType([_PropTypes.string, _PropTypes.func, _PropTypes.object]),
  "children": _PropTypes.node,
  "onFocus": _PropTypes.func,
  "tooltipProps": _PropTypes.object
};
StyledTab.displayName = "StyledTab";

export { StyledTab, Tab, defaultElement };
